import { COLUMNS_UNMOUNT_GRID } from "../actionTypes";

const initialState = {
    arrColumnMoviedTypess: [],
};
const columnsReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case COLUMNS_UNMOUNT_GRID.UPDATE_ARR_COLUMNS_UNMOUNT: {
            return {
                ...state,
                arrColumnMoviedTypess: actions.payload
            };
        }

        default: return state;

    }
};
export default columnsReducer;